import { getState, getStatePure, modifyState, unsetState } from '~src/state';
import { deleteTmpAnimationObject } from '~video';
import { triggerStateChangedRequest } from '~core';
import { onErrorShowMessage } from '~src/errors';

export const onHideObjectAnimation = (event) => {
  event.preventDefault();

  const activeObject = window.canvas.getActiveObject();

  if (!activeObject) {
    onErrorShowMessage("Seleziona l'oggetto che vuoi animare");
  }

  const objectsOriginalOpacity = [];
  const objectIds = [];
  if (activeObject.type === 'activeSelection') {
    for (const obj of activeObject.getObjects()) {
      objectsOriginalOpacity.push(obj.get('opacity'));
      obj.set({ opacity: 0 });
      objectIds.push(obj.giotto.objRefId);
    }
  } else {
    objectsOriginalOpacity.push(activeObject.get('opacity'));
    activeObject.set({ opacity: 0 });
    objectIds.push(activeObject.giotto.objRefId);
  }

  const pendingAnimation = {
    objects: objectIds,
    fromProps: {
      opacity: 0,
    },
  };
  modifyState('pendingAnimation', pendingAnimation);

  const pages = getStatePure('pages');
  const currentPageIndex = getState('currentPageIndex');
  if (!pages[currentPageIndex].animations) {
    pages[currentPageIndex].animations = [];
  }
  pages[currentPageIndex].animations.push(pendingAnimation);
  modifyState('pages', pages);
  unsetState('pendingAnimation');
  if (activeObject.type === 'activeSelection') {
    let i = 0;
    for (const obj of activeObject.getObjects()) {
      obj.set({ opacity: objectsOriginalOpacity[i++] });
    }
  } else {
    activeObject.set({ opacity: objectsOriginalOpacity[0] });
  }
  deleteTmpAnimationObject();
  triggerStateChangedRequest();
};
